const LEVELS = [
  {
    icon: 'fa-droplet',
    name: 'Basic Pooja',
    tagline: 'Simple Cleansing',
    featured: false,
    points: [
      'Simplified purification with basic puja items',
      'Cleansing bath and mantra chanting',
      'No idol or elaborate setup required',
      'Suitable for malas and daily-wear items',
    ],
  },
  {
    icon: 'fa-fire',
    name: 'Vedic Pooja',
    tagline: 'Recommended for Gemstones',
    featured: true,
    points: [
      'Performed by qualified Vedic experts',
      'Panchamrit purification of the stone',
      'Sacred mantras invoking cosmic energies',
      'Beej mantra jaap — 108 repetitions',
    ],
  },
  {
    icon: 'fa-om',
    name: 'Prana Pratishtha',
    tagline: 'Highest Consecration',
    featured: false,
    points: [
      'Conducted by learned priests versed in Vedic texts',
      'Complete shodashopachara — 16 traditional rituals',
      'Infuses living prana into the gemstone',
      'Personalized with your birth details and purpose',
    ],
  },
]

export default function EnergizationLevelsSection() {
  return (
    <section className="py-20 md:py-24 md:px-12 bg-white">
      <div className="container mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl mx-auto text-center space-y-3 mb-14">
          <div className="flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-secondary/50"></span>
            <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Choose Your Vidhi</span>
            <span className="h-px w-8 bg-secondary/50"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl uppercase leading-tight text-primary">
            Three Levels of <span className="text-gradient-gold font-bold block">Energization</span>
          </h2>
          <p className="text-xs md:text-sm leading-relaxed text-gray-500">
            From a simple cleansing to full prana pratishtha — the depth of the ritual is chosen to match the stone and its purpose.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
          {LEVELS.map((level) => (
            <div
              key={level.name}
              className={`relative flex flex-col rounded-3xl p-8 transition-all duration-300 ${
                level.featured
                  ? 'bg-[#140608] text-white border border-goldPrimary/25 shadow-2xl'
                  : 'bg-background border border-gray-200 hover:border-secondary/30 hover:shadow-md'
              }`}
            >
              {level.featured && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-secondary px-4 py-1 text-[9px] font-bold uppercase tracking-widest text-white shadow-lg">
                  Performed on every order
                </span>
              )}
              <div className={`flex h-14 w-14 items-center justify-center rounded-2xl ${level.featured ? 'bg-white/5 border border-white/10 text-secondary' : 'bg-primary/5 text-primary'}`}>
                <i className={`fa-solid ${level.icon} text-xl`}></i>
              </div>
              <p className={`mt-6 text-[10px] font-mono uppercase tracking-[0.3em] ${level.featured ? 'text-white/50' : 'text-primary/40'}`}>{level.tagline}</p>
              <h3 className={`mt-1 font-heading text-2xl uppercase font-bold ${level.featured ? 'text-gradient-gold' : 'text-primary'}`}>{level.name}</h3>
              <ul className="mt-6 space-y-3.5">
                {level.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm leading-relaxed">
                    <i className={`fa-solid fa-check mt-1 text-xs ${level.featured ? 'text-secondary' : 'text-secondary/80'}`}></i>
                    <span className={level.featured ? 'text-white/70' : 'text-gray-500'}>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
